<template>
    <div>
    <ImageBoxTemplate :img="img">
        <div class="d-flex flex-end direction-column w-35">
            <div class="fake-input">
                <input type="number" class="fake-input-number" v-model="result.number" @change="preventNegative()"
                    @input="$emit('update:modelValue', result)" min="0" />
                <CustomSelect :options="options" class="select-unit" v-model="result.type"
                    @update:modelValue="(e) => $emit('update:modelValue', result)" placeholder="Choisir"></CustomSelect>
            </div>
            <div class="label-calculators mt-20px">{{label}}</div>
        </div>
    </ImageBoxTemplate>
    </div>
</template>
<script>
import CustomSelect from '@/components/form/CustomSelect'
import ImageBoxTemplate from '@/components/ImageBoxTemplate'
export default {
    data() {
        return {
            result: {
                number: '',
                type: 'm'
            },
            options: [
                {
                    label: "m²",
                    value: "m²"
                },
                {
                    label: "pi²",
                    value: "pi²"
                },
            ]
        }
    },
    props:{
        img:{
            type:String,
            default:"/calculateur-carbone-eclore/images/market.png"
        },
        label:{
            type:String,
            default:"Superficie de l’évènement"
        }
    },
    methods: {
        preventNegative() {
            if (this.result.number < 0) {
                this.result.number = 0;
            }
        }
    },
    components: {
        CustomSelect,
        ImageBoxTemplate
    }
}
</script>
<style scoped>
.fake-input {
    display: flex;
    align-items: center;
    border: 3px solid var(--Secondary-Noir, #3B3B3C);
    box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    text-align: right;
}
.fake-input-number {
    width: 100%;
    height: 100%;
    font-size: 30px;
    padding: 22px 35px;
    border: none;
    box-sizing: border-box;
}
.w-35{
    width:35%;
}
.flex-end {
    align-items: end;
}

.select-unit {
    margin-bottom: 20px;
    margin-right: 10px;
}
@media screen and (max-width: 750px) {
    .w-35{
        width:100%;
    } 
    .fake-input-number {
        font-size: 20px;
    }
}
@media screen and (max-width: 600px) {
    .white-container-no-padding {
        flex-wrap: wrap;
    }

    .mobile-w-100 {
        width: 100%;
    }

    .mobile-w-100>img {
        width: 100%;
    }

    .fake-input {
        width: 100%;
    }
}
</style>